// @ts-ignore
import Avatar from '@react/react-spectrum/Avatar'
import React, { useState } from 'react'
import { ProjectListType } from './ProjectList'
import styles from '@styles/components/ProjectListHeader.module.scss'
import { ActionButton, Button, Icon } from 'ui'
import CrossIcon from '/public/s2_icon_cross.svg'
import { useIsMobileLayout } from '@hooks/useMobileLayout'
import { CommunityShareLink } from './ShareLink'
import { useTranslations } from 'use-intl'

export const CommunityProjectsHero = () => {
  const t = useTranslations()
  const isMobileLayout = useIsMobileLayout()
  const [dismissed, setDismissed] = useState(false)

  return (
    <div
      style={{
        paddingBottom: isMobileLayout ? 18 : 0,
        transition: 'height 0.3s ease-out',
        // @TODO: transition this
        display: dismissed ? 'none' : 'block',
        height: dismissed ? 0 : 'initial'
      }}
      data-testid="project-list-header"
      className={styles['container']}>
      <div className={styles['hero']}>
        <div className={styles['currentuser-hero-dismiss']}>
          <ActionButton
            onClick={() => setDismissed(true)}
            quiet
            size="s"
            staticColor="black"
            slot="trigger">
            <Icon slot="icon">
              <CrossIcon />
            </Icon>
          </ActionButton>
        </div>
        <div className={styles['hero-text-container']}>
          <h1>{t('page:community:hero:header')}</h1>
          <span>{t('page:community:hero:body')}</span>
          <>
            <Button
              onClick={() =>
                window.open(
                  process.env.NEXT_PUBLIC_CLIENT_DEFAULT_REMIXABLE_PROJECT,
                  '_blank'
                )
              }
              size="l"
              variant="primary">
              {t('page:community:hero:button')}
            </Button>
          </>
        </div>
        <div className={styles['image-stack']}>
          <img
            className={styles['image-1']}
            src="landing_page/community_collage_1.png"
            alt="Image 1"
          />
          <img
            className={styles['image-2']}
            src="landing_page/community_collage_2.png"
            alt="Image 2"
          />
          <img
            className={styles['image-3']}
            src="landing_page/community_collage_3.png"
            alt="Image 3"
          />
        </div>
      </div>
    </div>
  )
}

export const CurrentUserProjectsHero = () => {
  const t = useTranslations()
  const [dismissed, setDismissed] = useState(false)

  return (
    <div
      style={{
        transition: 'height 0.3s ease-out',
        paddingTop: 0,
        // @TODO: transition this
        display: dismissed ? 'none' : 'block',
        height: dismissed ? 0 : 'initial'
      }}
      data-testid="project-list-header"
      className={styles['container']}>
      <div className={styles['currentuser-hero']}>
        <div className={styles['currentuser-hero-dismiss']}>
          <ActionButton
            onClick={() => setDismissed(true)}
            quiet
            size="s"
            staticColor="black"
            slot="trigger">
            <Icon slot="icon">
              <CrossIcon />
            </Icon>
          </ActionButton>
        </div>
        <div className={styles['currentuser-hero-text-container']}>
          <p>{t('page:myProjects:hero:header')}</p>
          <span>{t('page:myProjects:hero:body')}</span>
          <>
            <Button
              onClick={() => window.open(CommunityShareLink, '_blank')}
              size="l"
              variant="primary"
              treatment="outline">
              {t('page:myProjects:hero:button')}
            </Button>
          </>
        </div>
        <div className={styles['currentuser-image-stack']}>
          <img
            className={styles['image-1']}
            src="landing_page/community_collage_1.png"
            alt="Image 1"
          />
          <img
            className={styles['image-2']}
            src="landing_page/community_collage_2.png"
            alt="Image 2"
          />
          <img
            className={styles['image-3']}
            src="landing_page/community_collage_3.png"
            alt="Image 3"
          />
        </div>
      </div>
    </div>
  )
}

export const UserProfileProjectListHeader = ({
  avatar,
  username,
  totalCount
}: Partial<{
  avatar?: string
  username?: string
  projectListType: ProjectListType
  totalCount: number
}>) => {
  const t = useTranslations()

  return (
    <div data-testid="project-list-header" className={styles['container']}>
      <div className={styles['profile-title-container']}>
        {avatar && <Avatar className={styles['profile-avatar']} src={avatar} />}
        <h2 className={styles['profile-title']}>{username}</h2>
        <span className={styles['profile-subtitle']}>
          {totalCount && totalCount > 0
            ? t('page:userProfile:projectCount', {
                userProjectCount: totalCount
              })
            : ''}
        </span>
      </div>
    </div>
  )
}
